<template>
    <div class="container-masterdata">
        <MasterDataModal v-if="isModalVisible" title="Stammdaten hinzufügen" :show="isModalVisible"
            :latestMasterData="latestMasterData" :publicHolidayRegions="publicHolidayRegions" @close="closeModal"
            @update="loadMasterData">
        </MasterDataModal>
        
        <button class="btn-update btn-right" @click="openModal">Stammdaten hinzufügen</button>
        <table class="table">
            <tr>
                <th>Gültig ab</th>
                <th>Üblicher Arbeitsbeginn</th>
                <th>Übliches Arbeitsende</th>
                <th>Beginn der üblichen Pausenzeit</th>
                <th>Ende der üblichen Pausenzeit</th>
                <th>Feiertagsregion</th>
            </tr>
            <tr v-for="(masterData, index) in masterDataArray" :key="index">
                <td>{{ new Intl.DateTimeFormat('de-DE', {
            day: '2-digit', month: '2-digit', year: 'numeric'
        }).format(new Date(masterData.updated)) }}</td>
                <td>{{ masterData.workWindowStart }}</td>
                <td>{{ masterData.workWindowEnd }}</td>
                <td>{{ masterData.breakWindowStart }}</td>
                <td>{{ masterData.breakWindowEnd }}</td>
                <td>{{ this.publicHolidayRegions.find(region => region.guid === masterData.publicHolidayRegion).name }}
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import apiService from '@/service';
import MasterDataModal from './MasterDataModal.vue';

export default {
    name: "MasterDataComponent",
    components: {
        MasterDataModal
    },
    data() {
        return {
            publicHolidayRegions: [],
            masterDataArray: [],
            latestMasterData: [],
            isModalVisible: false
        };
    },
    mounted() {
        if (localStorage.getItem("isLoggedIn") != "true") {
            this.$router.push('/');
            return;
        }

        this.loadPublicHolidayRegions();
        this.loadMasterData();
    },
    methods: {
        loadPublicHolidayRegions() {
            apiService.get(`/User/GetPublicHolidaySelections`)
                .then(response => {
                    this.publicHolidayRegions = response.data.map(item => {
                        return {
                            guid: item.guid,
                            name: item.name
                        }
                    })
                })
                .catch(error => {
                    console.log('GetMasterData error:', error);
                })
                .finally(() => {
                    console.log('GetMasterData finally:');
                });
        },
        loadMasterData() {
            apiService.get(`/User/GetAllMasterData`)
                .then(response => {
                    this.masterDataArray = response.data.map(item => {
                        return {
                            masterDataId: item.masterDataId,
                            userLogin: item.userLogin,
                            workWindowStart: item.workWindowStart.slice(0, 5),
                            workWindowEnd: item.workWindowEnd.slice(0, 5),
                            breakWindowStart: item.breakWindowStart.slice(0, 5),
                            breakWindowEnd: item.breakWindowEnd.slice(0, 5),
                            updated: item.updated,
                            publicHolidayRegion: item.publicHolidayRegion
                        }
                    })

                    this.latestMasterData = this.masterDataArray.sort((a, b) => new Date(b.updated) - new Date(a.updated))[0];
                })
                .catch(error => {
                    console.log('GetMasterData error:', error);
                })
                .finally(() => {
                    console.log('GetMasterData finally:');
                });
        },
        closeWarning() {
            this.loginFailed = false;
        },
        openModal() {
            this.isModalVisible = true;
        },
        closeModal() {
            this.isModalVisible = false;
        },
    },
};
</script>
<style>
.container-masterdata {
    display: flex;
    flex-direction: column;
    gap: 1rem
}

.btn-right {
    align-self: end;
}
</style>